import { Component, Input, OnInit } from '@angular/core';

export type ContainerImage = {
  name: string;
  classes?: Array<string>;
  styles?: { [key: string]: any };
};

@Component({
  selector: 'app-content-with-image',
  templateUrl: './content-with-image.component.html',
  styleUrls: ['./content-with-image.component.scss'],
})
export class ContentWithImageComponent implements OnInit {
  @Input() public templateType: string = 'variant-1';
  @Input() public currentPath?: string = '';
  @Input() public image: ContainerImage = { name: 'registration' };
  constructor() {}

  ngOnInit(): void {}
}
